import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../context/LanguageContext';

export const SEO = ({ 
  title,
  description,
  keywords,
  canonical,
  type = 'website',
  image
}) => {
  const { language } = useLanguage();
  
  const defaults = {
    tr: {
      title: 'AgrosTech | Size Özel Yazılım Çözümleri',
      description: 'AgrosTech, işletmenize özel yazılım çözümleri geliştiren bir yazılım şirketidir. Kurye yönetimi, veteriner takip, e-ticaret ve vardiya planlama sistemleri geliştiriyoruz.',
      keywords: 'yazılım geliştirme, özel yazılım, kurye yazılımı, veteriner yazılımı, e-ticaret yazılımı, vardiya planlama, mobil uygulama, web uygulaması, AgrosTech'
    },
    en: {
      title: 'AgrosTech | Custom Software Solutions',
      description: 'AgrosTech is a software company that develops custom software solutions for your business. We develop courier management, veterinary tracking, e-commerce and shift planning systems.',
      keywords: 'software development, custom software, courier software, veterinary software, e-commerce software, shift planning, mobile app, web application, AgrosTech'
    }
  };

  const siteUrl = 'https://agrostech.net';
  const defaultImage = `${siteUrl}/og-image.png`;

  const seo = {
    title: title || defaults[language].title,
    description: description || defaults[language].description,
    keywords: keywords || defaults[language].keywords,
    canonical: canonical || siteUrl,
    image: image || defaultImage,
    type
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <html lang={language} />
      <title>{seo.title}</title>
      <meta name="title" content={seo.title} />
      <meta name="description" content={seo.description} />
      <meta name="keywords" content={seo.keywords} />
      
      {/* Canonical */}
      <link rel="canonical" href={seo.canonical} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={seo.type} />
      <meta property="og:url" content={seo.canonical} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:locale" content={language === 'tr' ? 'tr_TR' : 'en_US'} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={seo.canonical} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
    </Helmet>
  );
};
